
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { TimelineEvent } from '@/interfaces/timeline';

@Options({})
export default class TimelineEventComponent extends Vue {
  @Prop({ required: true })
  event!: TimelineEvent;

  @Prop({ required: true })
  position!: 'above' | 'below';

  @Prop({ default: false })
  isSelected!: boolean;

  @Prop({ required: true })
  onSelect!: (event: TimelineEvent) => void;

  private isHovered = false;
  private hasError = false;

  handleClick(): void {
    try {
      this.onSelect(this.event);
    } catch (error) {
      console.error('Error in TimelineEvent click handler:', error);
      this.hasError = true;
      this.$emit('error', error);
    }
  }

  handleHover(hovered: boolean): void {
    try {
      this.isHovered = hovered;
    } catch (error) {
      console.error('Error in TimelineEvent hover handler:', error);
      this.hasError = true;
      this.$emit('error', error);
    }
  }
}
